<template>
  <v-card>
    <v-card-title class="headline py-2">
      Анкета
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close-dialog')" class="mx-0"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text>
      <v-layout row wrap id="to-print" class="py-2">
        <v-flex xs12 sm3 class="pa-4 text-xs-center">
          <img :src="form_photo" alt="avatar" width="100%" style="max-width: 300px">
        </v-flex>
        <v-flex xs12 sm9 class="pa-4">
          <v-btn color="secondary" small class="pull-right hide-on-print" @click="printAnketa">
            Печатать
          </v-btn>
          <div class="subheading py-2" v-for="(field, index) in form.default" :key="index">
            <b>{{field.name}}: </b> <span v-if="field.value!=null">{{formatValue(field.value)}}</span><small v-else>(не заполнено)</small>
          </div>
        </v-flex>
        <v-flex xs12 sm6 class="px-4 py-0" v-for="(field, index) in form.other" :key="index">
          <div class="subheading py-2">
            <b>{{field.name}}: </b> <span v-if="field.value!=null">{{formatValue(field.value)}}</span><small v-else>(не заполнено)</small>
          </div>
        </v-flex>
        <v-flex xs12 class="px-4" v-if="posts.length>0">
          <p class="subheading mb-0"><b>Другие посты в компании, занимаемые данным сотрудником:</b></p>
          <ul class="pl-3">
            <li v-for="(post, index) in posts" :key="index">{{post.name}} <v-chip
              :color="post.active?'green lighten-4':'red lighten-4'"
              label disabled
              small
              class="ml-0"
            >{{post.date}}</v-chip></li>
          </ul>
        </v-flex>
      </v-layout>
    </v-card-text>
    
  </v-card>
</template>

<script>
  export default {
    name : 'AnketaArchived',
    
    props:{
      form: {
        type: Object,
        required: true
      },
      posts: {
        type: Array,
        required: true
      },
      form_photo: {
        type: String,
        required: true
      }
    },
    
    data() {
      return {
     
      }
    },
    
    methods : {
      formatValue(data){
        switch(typeof data){
          case 'string': return data;
          case 'boolean': return data ? 'Да' : 'Нет'
          case 'object':
            let result = ''
            for(let item of data) result+=item+', '
            return result.trim()
        }
      },
      
      printAnketa(){
        const mywindow = window.open('', 'PRINT', 'height=600,width=900');
        mywindow.document.write('<html><head><title>Анкета</title>');
        mywindow.document.write('<style>.hide-on-print{display:none}</style></head><body >');
        mywindow.document.write(document.getElementById('to-print').innerHTML);
        mywindow.document.write('</body></html>');
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        mywindow.print();
        mywindow.close();
        return true;
      },
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Anketa/AnketaArchived.vue